<template>
  <!-- App.vue -->

  <v-app style="background-color: #F5F5F5" v-if="getUser != null">
    <!--  navigation  -->
    <NavigationDrawerStudent :open="mini" class="sideBar" v-on:close="mini = false" v-if="getUser != null"/>

    <v-app-bar app dense color="white" class="topBar" v-if="getUser != null">
      <!-- -->
      <v-icon @click="mini = !mini" color="black">mdi-menu</v-icon>
      <v-spacer></v-spacer>
      <div class="nav-actions">
        <!--    avatar    -->
        <v-avatar :size="isMobile ? 24 : 32" :class="{'mr-2': isMobile}">
          <v-img :src="image"></v-img>
        </v-avatar>
        {{ getUser != null ? getUser.name.split(' ')[0] : '' }}

      </div>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main id="main-app" v-if="getUser != null">

      <!-- Provides the application the proper gutter -->
      <v-container fluid style="height: 100%">

        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>

  <v-app style="background-color: #F5F5F5" v-else>
    <v-main>

      <!-- Provides the application the proper gutter -->
      <v-container fluid style="height: 100%">
        <div class="d-flex flex-column" style="height: 100%">
          <div class="mx-auto my-auto">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import NavigationDrawerStudent from "./components/NavigationDrawerStudents";
import ErrorResolver from "@/shared/ErrorResolver";
import Api from "@/main/api";
import LoginUtil from "../login/LoginUtil";
import Defaults from "@/shared/Defaults";
import Roles from "@/shared/Roles";
import StudentStatus from "@/shared/StudentStatus";

export default {
  name: 'App',
  components: {
    NavigationDrawerStudent,
  },

  data: () => ({
    mini: false,
    viewOption: 1, // to put in vuex state
    programmeTypes: [],
    image: '',
    links: ['Logout', 'Settings']
  }),

  methods: {
    ...mapActions(['fetchCurrentUser', 'fetchProgrammeTypes']),
    setProgrammeType(val){
      let v = this;
      Api.session.current(val.id).then(res => {
        v.$store.commit('setCurrentSession', res.data);
        this.$store.commit('setCurrentProgrammeType', val)
      }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      })
    },


  },

  watch: {
    getUser: function(newVal){
      if(newVal != null){
        this.image = Defaults.api + '/profile-picture/fetch?user=' +  this.getUser.userId;
      }
    }
  },

  computed: {
    ...mapGetters(['getProgrammeTypes', 'getCurrentProgrammeType', 'getUser']),
    isMobile: function(){
      return this.$vuetify.breakpoint.smAndDown
    },
    isLarge: function(){
      return this.$vuetify.breakpoint.lgAndUp
    },
  },

  mounted() {
    Api.schools.getDominant().then((res) => {
        this.title = res.data.name;
          document.title = this.title // change the page title
    }).catch((err) => ErrorResolver.checkErrors(err, err))

    const urlParams = new URLSearchParams(window.location.search);
    const reference = urlParams.get('reference');
    if (reference) {
      Api.payment.processInline(reference)
        .then(() => {
          console.log('Payment processed:', reference)
          window.history.replaceState({}, document.title, window.location.pathname + window.location.hash)
        })
        .catch(err => ErrorResolver.checkErrors(this, err))
    }
  },

  created() {
    // get token if exist
    if(LoginUtil.checkAuth()){
      this.fetchCurrentUser().then(res => {
        // must be a student or applicant that has accepted admission
        if(res.data.user && !(Roles.contains(res.data.user.roles, Roles.Student) || (Roles.contains(res.data.user.roles, Roles.Applicant) && StudentStatus[res.data.user.studentStatus].value >= StudentStatus[res.data.user.yearOfAdmission?.programmeType?.studentDashboardAccessStatus ?? StudentStatus.CLEARED.text].value))){
          // if an applicant
          if(StudentStatus[res.data.user.studentStatus].value < StudentStatus[res.data.user.yearOfAdmission?.programmeType?.studentDashboardAccessStatus ?? StudentStatus.CLEARED.text].value){
            window.location.href = '/application';
            return;
          }
          // log user out
          LoginUtil.resetAccessToken()
          LoginUtil.resetRefreshToken()
          // window.location.href = '/login'
          return
        }
        this.$store.commit('setCurrentUser', res.data)
      }).catch(err => ErrorResolver.checkErrors(this, err))

      this.fetchProgrammeTypes().then(res => {
        this.$store.commit('setProgrammeType', res.data)
        this.programmeTypes = res.data
        if(res.data.length > 0){
          this.$store.commit('setCurrentProgrammeType', res.data[0])
        }

      }).catch(err => {
        ErrorResolver.checkErrors(this, err);
      })
    } else{
      window.location.href = '/login'
    }
  }

};
</script>
<style lang="css">
.nav-actions > *{
  margin-left: 16px;
}


@import '../resources/styles/global.css';
</style>
